import PropTypes from 'prop-types';
import React from 'react';
import { contentfulModels } from '@glowforge/ui-common';
import { articlePropTypes } from 'app/selectors/support';
import Article from 'app/components/support/article';
import ArticleStepGroup from './article-step-group';
import ActionButtons from './action-buttons';

import './shared.less';

const { pageStringsPropType } = contentfulModels;

const Instructions = ({
  pageStrings,
  pageMarkdownStrings,
  onNext,
  headerArticle,
  unboxArticle,
  printHeadArticle,
  cuttingTrayArticle,
}) => (
  <div className='Instructions PageContainer'>
    <Article {...headerArticle} />
    <ArticleStepGroup article={unboxArticle} />
    <ArticleStepGroup article={printHeadArticle} />
    <ArticleStepGroup article={cuttingTrayArticle} />
    <ActionButtons
      getHelpMarkdownSource={pageMarkdownStrings['instructions-get-help']}
      nextStepOnClick={onNext}
      nextStepStr={pageStrings['instructions-next-step']} />
  </div>
);

Instructions.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  onNext: PropTypes.func.isRequired,
  headerArticle: PropTypes.shape(articlePropTypes),
  unboxArticle: PropTypes.shape(articlePropTypes),
  printHeadArticle: PropTypes.shape(articlePropTypes),
  cuttingTrayArticle: PropTypes.shape(articlePropTypes),
};

Instructions.defaultProps = {
  headerArticle: {},
  unboxArticle: {},
  printHeadArticle: {},
  cuttingTrayArticle: {},
};

export default Instructions;



// WEBPACK FOOTER //
// ./app/components/setup/instructions.jsx